@if (client$ | async; as client) {
    @if (!client.is_paid && client.paid_members >= client.member_quota) {
        <button mat-stroked-button routerLink="/pricing" color="primary">Upgrade Account</button>
    } @else {
        <button mat-stroked-button color="primary" (click)="openInviteDialog(client.id)">
            <mat-icon>add</mat-icon>
            Invite
        </button>
    }
}
